import useMediaLibrarySearchResult from '~modules/media-library/context/useMediaLibrarySearchResult';
import useMediaLibrarySettings from '~modules/media-library/context/useMediaLibrarySettings';
import useMediaLibraryUserPreferences from '~modules/media-library/context/useMediaLibraryUserPreferences';
import { ViewContext } from '~modules/media-library/model/ViewContext';
import { ResultHeader } from '~modules/media-library/view/ResultHeader/ResultHeader';

export default function ResultHeaderController() {
  const { isFavouritesEnabled, sortOptions, viewVariants, viewContext } = useMediaLibrarySettings();
  const { sortKey, sortOrder, onSort, viewVariant, onChangeViewVariant, showFavouritesOnly, toggleShowFavouritesOnly } =
    useMediaLibraryUserPreferences();
  const { resultCount, isLoading } = useMediaLibrarySearchResult();

  return (
    <ResultHeader
      assetCount={resultCount}
      showFavouritesOnly={showFavouritesOnly}
      showFavouritesToggle={viewContext !== ViewContext.FAVOURITE}
      viewContext={viewContext}
      onToggleShowFavouritesOnly={isFavouritesEnabled && toggleShowFavouritesOnly}
      sortOptions={sortOptions}
      sortKey={sortKey}
      sortOrder={sortOrder}
      onSort={onSort}
      viewVariant={viewVariant}
      viewVariants={viewVariants}
      onChangeView={onChangeViewVariant}
      isLoading={isLoading}
    />
  );
}
